<div class="wrapper ion-justify-content-center">
	<div class="add-promocode-wrapper">
		<ion-icon name="pricetags-outline"></ion-icon>
		<div class="name-of-promo">
			{{ promoCode.name }}
		</div>
		<!-- <div class="button" (click)="checkPromoCode()">Hinzufügen</div> -->
		<div class="edit_section">
			<ion-icon name="trash-outline" (click)="onRemoveClickHandler()"></ion-icon>
		</div>
	</div>
</div>
